
import store from '@/store'
// MQTT
import mqtt from 'mqtt'
import yhubproto from '@/proto/yhubproto'
import protobuf from 'protobufjs'
import { MQTT_SERVICE, MQTT_USERNAME, MQTT_PASSWORD } from '@/utils/sysconstant.js'
const YhubRequest = yhubproto.lookup('framework.YhubRequest')
var options = {}
client = mqtt.connect(MQTT_SERVICE, options)
var client
export function MQTT () {
  options = {
    connectTimeout: 40000,
    // clientId: this.deviceID,
    username: MQTT_USERNAME,
    password: MQTT_PASSWORD,
    clean: true
  }
  // mqtt连接
  // console.log('mqtt======')
  client.on('connect', (e) => {
    console.log('mqtt连接成功````:' + MQTT_SERVICE, options)
    client.subscribe('gpd/p/04/#', { qos: 1 }, (error) => {
      if (!error) {
        console.log('订阅成功')
      } else {
        console.log('订阅失败')
      }
    })
  })
  // 接收消息处理
  client.on('message', (topic, message) => {
    // 判断response是否是arrayBuffer
    // if (!topic.match(this.mcuId)) { return }

    // this.topic = topic
    var yhubRequest
    try {
      const buf = protobuf.util.newBuffer(message)
      var newBuffer = buf.slice(0, buf.length - 2)
      // if (topic.indexOf('gpd/p/04/') > -1) {
      yhubRequest = YhubRequest.decode(newBuffer)
      yhubRequest.topic = topic

      // console.log('收到数据mqtt==>', yhubRequest)
      store.dispatch('setYhubmqtt', yhubRequest)

      // }
    } catch (err) {
      // this.msg = err.toString()
      return err
    }

    // sessionStorage.setItem('yhubRequest', JSON.stringify(yhubRequest))
    // console.log(store)
  })
  // 断开发起重连
  client.on('reconnect', (error) => {
    console.log('正在重连:', error)
  })
  // 链接异常处理
  client.on('error', (error) => {
    console.log('连接失败:', error)
  })
}
